import React from 'react';

import Banner from '@adsk/alloy-react-banner';
import { Trans } from '@adsk/alloy-react-localization';

import { useTranslation } from './i18n';

const DocsCustomTopBanner = ({ multiple }) => {
  const shouldHideBanner = localStorage.getItem(
    'file-reference-picker-hide-banner',
  );
  const [isOpen, setIsOpen] = React.useState(shouldHideBanner !== 'true');
  const setClose = () => {
    try {
      localStorage.setItem('file-reference-picker-hide-banner', true);
    } catch (e) {
      console.error(e);
    }
    setIsOpen(false);
  };
  const { t, i18n } = useTranslation();
  return multiple && isOpen ? (
    <Banner
      inline
      message={
        <div>
          <Trans
            i18n={i18n}
            t={t}
            i18nKey="SHIFT_SELECTION_BANNER_MESSAGE"
            components={{ 1: <strong /> }}
          />
        </div>
      }
      variant={Banner.VARIANTS.PRIMARY}
      open={isOpen}
      onClose={setClose}
    />
  ) : null;
};

export default DocsCustomTopBanner;
